import React, { useState } from 'react';
import __ from 'utils/i18n';
import { getConfig } from 'config';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardText
} from "reactstrap";

export const FirstEquipmentModal = () => {
  const [showModal, setShowModal] = useState(true);
  const hideModal = () => setShowModal(false)
  const imgs = getConfig('customConfig.standalone.firstModal') || {};

  const steps = [
    {
      title: __("dashboard.sections.standalone.modal.title.calcuaterStandalone"),
      text: __("dashboard.sections.standalone.modal.calcuaterStandalone"),
      img: imgs.calcuaterImg || null,
    },
    {
      title: __("dashboard.sections.standalone.modal.title.labelStandalone"),
      text: __("dashboard.sections.standalone.modal.labelStandalone"),
      img: imgs.labelImg || null,
    },
    {
      title: __("dashboard.sections.standalone.modal.title.monitorStandalone"),
      text: __("dashboard.sections.standalone.modal.monitorStandalone"),
      img: imgs.monitorImg || null,
    },
  ];

  return (
    <Modal
      isOpen={showModal}
      toggle={hideModal}
      zIndex={1000000}
      size={'lg'}
    >
      <ModalHeader className="text-center justify-content-center">{__("dashboard.sections.standalone.modal.title.firstEquipment")}</ModalHeader>
      <ModalBody className="pb-3">
        <p className="text-center mb-3">{__("dashboard.sections.standalone.modal.firstEquipmentText")}</p>
        <Row className="justify-content-center" noGutters>
          {steps.map((step, index) => (
            <Col md={4} key={index} className="mb-4 d-flex flex-column align-items-center">
              <Card className="w-100 h-100 border-0 shadow-sm">
                <div className="text-center p-3">
                  <img
                    src={step.img}
                    alt={step.title}
                    style={{ width: '100%', objectFit: 'contain' }}
                  />
                </div>
                <CardBody className="px-3 pb-3">
                  <CardTitle tag="h5" className="text-center">{step.title}</CardTitle>
                  <CardText className="text-center">{step.text}</CardText>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </ModalBody>
      <ModalFooter className="text-center justify-content-center pb-2">
        <Button color="link" onClick={hideModal}>{__('actions.understood')}</Button>
      </ModalFooter>
    </Modal>
  );
};
